const FAQS = [
  ["Where can I take the Hilux?", "Darwin region, Litchfield National Park, Kakadu (sealed sections), Berry Springs and Adelaide River. No Cape York, no Gibb River Road, no interstate without written approval."],
  ["What is the bond?", "Hilux A$5,000 (or A$500 with excess reduction A$65/day). Kluger A$3,000 (or A$500 with excess reduction A$35/day). The bond equals your maximum damage liability (excess) — standard in the NT for 4WD hire. Pre-authorised on your card at pickup, released within 7 days of return."],
  ["What is the minimum age?", "21 for the Kluger, 25 for the Hilux. Full license, held for at least 2 years. Under-25 surcharge on Kluger is A$25/day."],
  ["When is the deposit charged?", "Only after we approve your booking. Deposit is 25% of total. Non-refundable within 14 days of pickup."],
  ["How does the kilometre allowance work?", "Bookings of 5 days or more get unlimited kilometres included. Bookings under 5 days have a 250 km/day allowance; any kilometres over that are billed at A$0.35/km and captured from your bond at return."],
  ["Where do I pick up the vehicle?", "Our base is in Leanyer, Darwin NT 0812 — just 5–10 minutes from Darwin Airport. The exact street address is emailed to you 48 hours before pickup, once the deposit is paid."],
  ["Cancellation policy", ">14 days: full refund less A$50. 7–14 days: 50% refund. <7 days: forfeit deposit."],
  ["Do you accept international licenses?", "Yes — English-language licenses or with a certified translation / IDP. Passport required as second ID."],
  ["Is there a GPS tracker?", "The Hilux is fitted with a GPS tracker. This is disclosed here and in the rental agreement. Driving outside the permitted area is a breach and voids your bond."],
];

export default function FAQ() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <div className="overline text-[#BA5A3A]">FAQ</div>
      <h1 className="text-4xl md:text-5xl font-black tracking-tighter mt-2">Straight answers</h1>
      <div className="mt-10 space-y-4">
        {FAQS.map(([q, a]) => (
          <details key={q} className="card-hard p-6 group" data-testid="faq-item">
            <summary className="cursor-pointer font-bold text-lg flex justify-between items-center">
              {q}<span className="text-[#BA5A3A] group-open:rotate-45 transition-transform text-2xl">+</span>
            </summary>
            <p className="mt-3 text-[#595959] leading-relaxed">{a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
